import React, { useContext } from "react";
import { menuContext } from "../../Context/menuContex";
import { MenuItem } from "../MenuItem";

export const MenuSection = () => {
	const { product } = useContext(menuContext);
	return (
		<section className=" flex flex-col self-center gap-2 pt-2">
			{["Perros", "Hamburguesas", "Sándwiches Gourmet"]
				.sort()
				.map((categoryName) => (
					<div key={categoryName} className=" flex flex-col gap-2">
						<h2 className="font-bold text-gray-500">{categoryName}</h2>
						{product
							.filter((item) => item.category_Name === categoryName)
							.map((filteredItem) => (
								<div key={filteredItem.id}>
									<MenuItem item={filteredItem} />
								</div>
							))}
					</div>
				))}
		</section>
	);
};
